export const GETTERS = {
  IS_LOADING: "IS_LOADING",
  IS_SAVING: "IS_SAVING",

  IS_FILE_LOADING: "IS_FILE_LOADING",
  IS_FILE_SAVING: "IS_FILE_SAVING",

  CARD_DATA: "CARD_DATA",
  CARD_IS_CHANGED: "CARD_IS_CHANGED",
  CARDS: "CARDS",
  COMPARED_CARDS: "COMPARED_CARDS",
  COMPARED_CARDS_DATA: "COMPARED_CARDS_DATA",

  DICTIONARY_4: "DICTIONARY_4",
  DICTIONARY_5: "DICTIONARY_5",
  DICTIONARY_6: "DICTIONARY_6",
  DICTIONARY_7: "DICTIONARY_7",
  DICTIONARY_8: "DICTIONARY_8",
  DICTIONARY_10: "DICTIONARY_10",
  DICTIONARY_11: "DICTIONARY_11",
  DICTIONARY_12: "DICTIONARY_12",
  DICTIONARY_13: "DICTIONARY_13",
  DICTIONARY_14: "DICTIONARY_14",
  DICTIONARY_17: "DICTIONARY_17",
  DICTIONARY_18: "DICTIONARY_18",
  DICTIONARY_19: "DICTIONARY_19",
  DICTIONARY_20: "DICTIONARY_20",
  DICTIONARY_21: "DICTIONARY_21",
  DICTIONARY_22: "DICTIONARY_22",
  DICTIONARY_24: "DICTIONARY_24",
  DICTIONARY_25: "DICTIONARY_25",
  DICTIONARY_26: "DICTIONARY_26",
  DICTIONARY_27: "DICTIONARY_27",
  DICTIONARY_28: "DICTIONARY_28",
  DICTIONARY_29: "DICTIONARY_29",
  DICTIONARY_30: "DICTIONARY_30",
  DICTIONARY_33: "DICTIONARY_33",
  DICTIONARY_34: "DICTIONARY_34",
  DICTIONARY_36: "DICTIONARY_36",

  DICTIONARY_100: "DICTIONARY_100",
  DICTIONARY_101: "DICTIONARY_101",
  DICTIONARY_102: "DICTIONARY_102",
  DICTIONARY_103: "DICTIONARY_103",

  DICTIONARY_ITEM: "DICTIONARY_ITEM",

  USER_DATA: "USER_DATA",
  USER_IS_EXPERT: "USER_IS_EXPERT",
  USER_IS_AUTHENTICATED: "USER_IS_AUTHENTICATED",

  NOTIFICATIONS: "NOTIFICATIONS",
};

export const getters = {
  [GETTERS.IS_LOADING]: (state) => state.isLoading,
  [GETTERS.IS_SAVING]: (state) => state.isSaving,

  [GETTERS.IS_FILE_LOADING]: (state) => state.isFileLoading,
  [GETTERS.IS_FILE_SAVING]: (state) => state.isFileSaving,

  [GETTERS.DICTIONARY_4]: (state) => dictionary(state, 4),
  [GETTERS.DICTIONARY_5]: (state) => dictionary(state, 5),
  [GETTERS.DICTIONARY_6]: (state) => dictionary(state, 6),
  [GETTERS.DICTIONARY_7]: (state) => dictionary(state, 7),
  [GETTERS.DICTIONARY_8]: (state) => dictionary(state, 8),
  [GETTERS.DICTIONARY_10]: (state) => dictionary(state, 10),
  [GETTERS.DICTIONARY_11]: (state) => dictionary(state, 11),
  [GETTERS.DICTIONARY_12]: (state) => dictionary(state, 12),
  [GETTERS.DICTIONARY_13]: (state) => dictionary(state, 13),
  [GETTERS.DICTIONARY_14]: (state) => dictionary(state, 14),
  [GETTERS.DICTIONARY_17]: (state) => dictionary(state, 17),
  [GETTERS.DICTIONARY_18]: (state) => dictionary(state, 18),
  [GETTERS.DICTIONARY_19]: (state) => dictionary(state, 19),
  [GETTERS.DICTIONARY_20]: (state) => dictionary(state, 20),
  [GETTERS.DICTIONARY_21]: (state) => dictionary(state, 21),
  [GETTERS.DICTIONARY_22]: (state) => dictionary(state, 22),
  [GETTERS.DICTIONARY_24]: (state) => dictionary(state, 24),
  [GETTERS.DICTIONARY_25]: (state) => dictionary(state, 25),
  [GETTERS.DICTIONARY_26]: (state) => dictionary(state, 26),
  [GETTERS.DICTIONARY_27]: (state) => dictionary(state, 27),
  [GETTERS.DICTIONARY_28]: (state) => dictionary(state, 28),
  [GETTERS.DICTIONARY_29]: (state) => dictionary(state, 29),
  [GETTERS.DICTIONARY_30]: (state) => dictionary(state, 30),
  [GETTERS.DICTIONARY_33]: (state) => dictionary(state, 33),
  [GETTERS.DICTIONARY_34]: (state) => dictionary(state, 34),
  [GETTERS.DICTIONARY_36]: (state) => dictionary(state, 36),

  [GETTERS.DICTIONARY_100]: (state) => dictionary(state, 100),
  [GETTERS.DICTIONARY_101]: (state) => dictionary(state, 101),
  [GETTERS.DICTIONARY_102]: (state) => dictionary(state, 102),
  [GETTERS.DICTIONARY_103]: (state) => dictionary(state, 103),

  [GETTERS.DICTIONARY_ITEM]: (state) => (idx, code) => {
    let data = undefined;
    if (state.dictionary[idx]) {
      data = state.dictionary[idx].data.get(code);
    }
    return data;
  },

  [GETTERS.CARD_DATA]: (state) => {
    const expLevel_state = state.card.expectedLevel || {};
    const expLevel_changes = state.changes.expectedLevel || {};
    const merge = {};
    merge.expectedLevel = Object.assign({}, expLevel_state, expLevel_changes);

    const target = state.changes.target || state.card.target || [];

    for (let prop in merge.expectedLevel) {
      if (!target.some((item) => item === prop)) {
        delete merge.expectedLevel[prop];
      }
    }

    // спец.слияние массивов infoSourceFiles и pilotProjectFiles
    merge.infoSourceFiles = state.card.infoSourceFiles || [];
    if (state.changes.infoSourceFiles) {
      merge.infoSourceFiles = merge.infoSourceFiles.concat(
        state.changes.infoSourceFiles
      );
    }
    merge.pilotProjectFiles = state.card.pilotProjectFiles || [];
    if (state.changes.pilotProjectFiles) {
      merge.pilotProjectFiles = merge.pilotProjectFiles.concat(
        state.changes.pilotProjectFiles
      );
    }

    const result = Object.assign({}, state.card, state.changes, merge);
    return result;
  },

  [GETTERS.CARD_IS_CHANGED]: (state) => Object.keys(state.changes).length > 0,

  [GETTERS.CARDS]: (state) => state.cards,

  [GETTERS.COMPARED_CARDS]: (state) => state.compared,

  [GETTERS.COMPARED_CARDS_DATA]: (state) => state.comparedData,

  [GETTERS.NOTIFICATIONS]: (state) => state.notifications,

  [GETTERS.USER_DATA]: (state) => state.user,

  [GETTERS.USER_IS_AUTHENTICATED]: (state) => state.user.tokens !== undefined,

  [GETTERS.USER_IS_EXPERT]: (state) => state.user.role === "expert",
};

const dictionary = (state, idx) => {
  const result = [];
  if (state.dictionary[idx]) {
    state.dictionary[idx].data.forEach((value) => result.push(value));
  }
  return result;
};
